<template>
  <div class="account-list">
    <div class="account-list__header">
      <div>{{ $t("message.common.accountType") }}</div>
      <div>{{ $t("message.common.added") }}</div>
      <div>{{ $t("message.common.actions") }}</div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "AccountListWrapper"
};
</script>

<style scoped lang="scss">
.account-list {
  &__header {
    display: flex;
    border-bottom: 1px solid $gray-200;
    @include font-size(12px);
    padding: $spacing * 2 $spacing;
    color: $gray-2;
    gap: $spacing;

    div:first-child {
      max-width: 150px;
    }
    div:last-child {
      width: 320px;
      flex-shrink: 0;
    }
    div {
      flex-grow: 1;
      width: 100%;
    }
  }
}
</style>
